<div fxLayout="column">
    <div fxFlex="56px" fxLayout="row" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxLayoutAlign="space-between center">
        <div fxFlex>
            <div fxLayout="row" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxLayoutAlign="start center">
                <app-package-packer-logo [externalApp]="appService.appTitle$ | async"></app-package-packer-logo>
            </div>
        </div>
        <div fxFlex>
            <div fxLayout="row" fxLayoutAlign="end center">
                <app-salesorg-dropdown
                    [availableOptions]="appService.availableLanguages$ | async"
                    [selectedLanguage]="appService.getLocation()"
                    (languageChanged)="onLanguageChanged($event)"
                    (salesOrgChanged)="onSalesOrgChanged($event)"
                ></app-salesorg-dropdown>
                <button
                    mat-icon-button
                    class="feedback-button"
                    (click)="openFeedbackDialog()"
                    *ngIf="(appService.appTitle$ | async) === ''"
                >
                    <img src="../../assets/icons/feedback.svg">
                </button>
                <a mat-icon-button [href]="faqLink" target="_blank">
                    <mat-icon>help_outline</mat-icon>
                </a>
                <vih-app-switcher [lang]="appService.getLanguage()"></vih-app-switcher>
                <vih-login
                    [appManagesAuthentication]="true"
                    [authenticated]="authenticated$"
                    [lang]="appService.getLanguage()"
                ></vih-login>
            </div>
        </div>
    </div>
</div>
